import * as React from "react";
import { useState } from "react";

type Props = {
  items: {
    title: string;
    content: any;
  }[];
};

const Accordion: React.FC<Props> = ({ items }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  const handleKeyDown = (event: React.KeyboardEvent, index: number) => {
    if (event.key === "Enter") {
      toggleAccordion(index);
    }
  };
  const handleClick = (index: number) => {
    toggleAccordion(index);
  };

  return (
    <div className="accordion">
      {items.map((item, index) => (
        <div key={index} className={`accordion__item ${openIndex === index ? "accordion__item--open" : ""}`}>
          <button
            className="accordion__title"
            onClick={() => handleClick(index)}
            onKeyDown={(event) => handleKeyDown(event, index)}
            tabIndex={0}
            role="button"
            aria-expanded={openIndex === index}
          >
            <p>{item.title}</p>
          </button>
          {openIndex === index && <div className="accordion__content">{item.content}</div>}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
